import { connect } from 'react-redux';
import PengisianNilaiAfek from '../../../views/Kurikulum/Ulangan/PengisianNilaiAfek.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(PengisianNilaiAfek);
